/* @flow */

import { compose } from 'ramda';
import { connect } from 'react-redux';

import CheckInNotificationDumb from './CheckInNotificationDumb';
import { markCheckInTakeOverAsOpen } from 'src/shared/app/check-in/action/uiCheckInActions';
import { dismissNotification } from 'src/shared/app/notification/action/uiNotificationActions';
import { getNotificationData } from 'src/shared/app/notification/util/notificationUtil';
import { trackGAEvent } from 'src/shared/core/service/tracking/gaService';
import { getSelf } from 'src/shared/domain/user/selector/userSelectors';

import type { Braindate } from '@e180/domain/lib/braindate/type';
import type { Notification } from 'src/shared/app/notification/type/notificationTypes';

type Props = {
  notification: Notification,
};

const mapStateToProps = (state: Object, { notification }: Props): Object => ({
  notification,
  user: getSelf(state),
});

const mapDispatchToProps = (dispatch: any): Object => ({ dispatch });

const mergeProps = (
  stateProps: Object,
  { dispatch }: Object,
  { notification }: Props,
): Object => ({
  ...stateProps,
  handleClick() {
    // $FlowIssue
    const braindate: Braindate = getNotificationData(notification);

    dispatch(markCheckInTakeOverAsOpen(braindate));

    trackGAEvent('Self check-in', 'Check in', 'Notification');
  },

  handleDismiss() {
    dispatch(dismissNotification(notification));

    trackGAEvent('Self check-in', 'Dismiss notification', 'Notification');
  },
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps, mergeProps),
)(CheckInNotificationDumb);
